import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b51929e")

_pushScopeId("data-v-0b51929e")
const _hoisted_1 = { class: "message-video-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoadedVideo)
      ? (_openBlock(), _createBlock("video", {
          key: 0,
          class: { '--is-widget': _ctx.isWidget },
          src: _ctx.videoLink,
          autoplay: "",
          controls: "",
          playsinline: "",
          "webkit-playsinline": ""
        }, null, 10, ["src"]))
      : (_openBlock(), _createBlock("iframe", {
          key: 1,
          class: { '--is-widget': _ctx.isWidget },
          src: _ctx.videoLink,
          frameborder: "0",
          allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: "allowfullscreen"
        }, "\n\t\t", 10, ["src"]))
  ]))
})